<template>
  <div class="button-container">
    <button
      class="button"
      v-for="number in buttonNumbers"
      :key="number.val"
      @click="goTo(number.val)"
    >
      Línea {{ number.name }}
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // Generamos un array con los números del 1 al 11
      buttonNumbers: 
        [
          {name: 1, val: 1},
          {name: 2, val: 2},
          {name: 3, val: 3},
          {name: 4, val: 4},
          {name: 5, val: 5},
          {name: 6, val: 6},
          {name: 8, val: 7},
          {name: 9, val: 8},
          {name: 11, val: 11},
      ],
    };
  },
  methods: {
    goTo(number) {
      this.$router.push(`linea/${number}`);
    },
  },
};
</script>

<style scoped>
.button-container {
  display: flex;
  flex-wrap: wrap; /* Permite que los botones se envuelvan a la siguiente fila */
  justify-content: center; /* Centra los botones horizontalmente */
  max-width: 400px; /* Ajusta el ancho máximo según tus necesidades */
  margin: 150px auto; /* Centra el contenedor y agrega espacio arriba y abajo */
}

.button {
  width: 45%; /* Cada botón ocupa casi la mitad del contenedor, deja espacio para márgenes */
  margin: 10px; /* Espacio entre los botones */
  padding: 15px; /* Aumenta el espaciado dentro del botón */
  text-align: center; /* Centra el texto dentro del botón */
  background-color: #007bff; /* Color de fondo del botón */
  color: white; /* Color del texto */
  border: none; /* Sin borde */
  border-radius: 5px; /* Bordes redondeados */
  cursor: pointer; /* Cambia el cursor al pasar por encima */
  font-size: 24px; /* Aumenta el tamaño del texto */
  transition: background-color 0.3s; /* Efecto de transición para el color de fondo */
}

.button:hover {
  background-color: #0056b3; /* Color de fondo al pasar el mouse */
}
</style>
